import { useState, useCallback } from 'react';

const STORAGE_KEY = 'theme';

export default function useDarkMode() {
  const [mode, setMode] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'light') return 'light';
      if (stored === 'dark') return 'dark';
      
      // Fallback to prefers-color-scheme system preference
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
      }
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
      }
      return 'dark'; // Fallback default
    } catch {
      return 'dark';
    }
  });

  const toggleMode = useCallback(() => {
    setMode((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // storage unavailable
      }
      return next;
    });
  }, []);

  return { mode, toggleMode };
}
